import { Link } from '@atlassian/amkt-common';
import React from 'react';
import SupportHours from './SupportHours';
const HoursOfOperationInformation = props => {
  var _props$supportDetails, _props$vendorLinks;
  const hasSupportHours = !!((_props$supportDetails = props.supportDetails.supportHours) !== null && _props$supportDetails !== void 0 && _props$supportDetails.timezone);
  const hasSla = !!((_props$vendorLinks = props.vendorLinks) !== null && _props$vendorLinks !== void 0 && _props$vendorLinks.sla);
  if (hasSupportHours || hasSla) {
    var _props$vendorLinks2;
    return /*#__PURE__*/React.createElement("div", null, (_props$vendorLinks2 = props.vendorLinks) !== null && _props$vendorLinks2 !== void 0 && _props$vendorLinks2.sla ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
      id: "vendor-sla",
      href: props.vendorLinks.sla
    }, "Service Level Agreement")) : null, /*#__PURE__*/React.createElement(SupportHours, props.supportDetails));
  }
  return /*#__PURE__*/React.createElement("p", null, "Please provide support hours.");
};
export default HoursOfOperationInformation;